module.exports = __webpack_public_path__ + "img/pdf.4f27f294.svg";